<template>
    <div class="tx-history-wrap">
        <table class="ui-table">
            <thead v-if="orders && orders.length > 0">
                <tr>
                    <th width="21">#</th>
                    <th>{{ $t('common.address') }}</th>
                    <th>
                        <div class="tx-table__cell tx-table__cell--align-right">{{ $t('multisig.executed') }}</div>
                    </th>
                    <th width="150">
                        <div class="tx-table__cell tx-table__cell--align-right">{{ $t('multisig.expires_at') }}</div>
                    </th>
                </tr>
            </thead>
            <template v-if="orders && orders.length > 0 && !isLoading">
                <tbody v-for="order in orders" v-bind:key="`ordersList_${order.order_seqno}`">
                    <tr>
                        <td>{{ order.order_seqno }}</td>
                        <td><ui-address v-bind:address="addressbook[order.address].user_friendly" /></td>
                        <td>
                            <div class="tx-table__cell tx-table__cell--align-right">{{ order.sent_for_execution ? $t('common.yes') : $t('common.no') }}</div>
                        </td>
                        <td>
                            <div class="tx-table__cell tx-table__cell--align-right">
                                <ui-datetime v-bind:timestamp="order.expiration_date" />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </template>
            <template v-else-if="orders && orders.length === 0 && !isLoading">
                <div class="tx-history-empty-panel">
                    {{ $t('multisig.addresslist_empty') }}
                </div>
            </template>
            <template v-else>
                <tbody v-for="i in 8" v-bind:key="`ordersList_skeleton_${i}`">
                    <td v-pre>
                        <span class="tx-table-cell-skeleton" style="width: 100%;"></span>
                    </td>
                </tbody>
            </template>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        orders: Array,
        addressbook: Object,
        isLoading: Boolean,
    },
};
</script>

<style lang="scss">

</style>
